// {
//   "name": "iconic-product-videos-second.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-video-gallery-with-product-second')) {
    return;
  }

  class IconicVideoGalleryProductsecond extends HTMLElement {
    constructor() {
      super();

      this.autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
      this.initAutoplayVideo = this.initAutoplayVideo.bind(this);
      this.toggleVideoPlayback = this.toggleVideoPlayback.bind(this);
      this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
      this.stopAllOtherVideos = this.stopAllOtherVideos.bind(this);
    }

    connectedCallback() {
      this.initAutoplayVideo();
    }

    initAutoplayVideo() {
      const Iconicvideos = this.querySelectorAll('video');
      Iconicvideos.forEach((video) => {
        if (this.autoplayEnabled && video.hasAttribute('autoplay')) {
          video.removeEventListener('click', this.toggleVideoPlayback);
          video.addEventListener('click', this.toggleVideoPlayback);
        }
      });

      const playButtons = this.querySelectorAll('.iconic-video-play-icon');
      playButtons.forEach((playButton) => {
        playButton.removeEventListener('click', this.handlePlayButtonClick);
        playButton.addEventListener('click', this.handlePlayButtonClick);
      });
    }

    toggleVideoPlayback(event) {
      const video = event.currentTarget;
      if (!this.autoplayEnabled) {
        this.stopAllOtherVideos(video);
      }

      const videoContainer = video.closest('.iconic-video-grid');
      const playIcon = videoContainer.querySelector('.iconic-video-play-button');
      const playIconSticky = videoContainer.querySelector('.iconic-sticky-play-icon');

      if (!video.paused) {
        video.pause();
        if (playIcon) playIcon.style.display = 'flex';
        if (playIconSticky) playIconSticky.style.display = 'block';
      } else {
        video.play();
        if (playIcon) playIcon.style.display = 'none';
        if (playIconSticky) playIconSticky.style.display = 'none';
      }
    }

    handlePlayButtonClick(event) {
      const playButton = event.currentTarget;
      const videoContainer = playButton.closest('.iconic-video-grid');
      const videoTag = videoContainer.querySelector('video');

      if (videoTag) {
        if (!this.autoplayEnabled) {
          this.stopAllOtherVideos(videoTag);
        }
        videoTag.play();
        videoTag.removeEventListener('click', this.toggleVideoPlayback);
        videoTag.addEventListener('click', this.toggleVideoPlayback);
      }

      const playIcon = videoContainer.querySelector('.iconic-video-play-button');
      const playIconSticky = videoContainer.querySelector('.iconic-sticky-play-icon');
      if (playIcon) playIcon.style.display = 'none';
      if (playIconSticky) playIconSticky.style.display = 'none';
    }

    stopAllOtherVideos(currentVideo) {
      const allVideos = this.querySelectorAll('video');
      allVideos.forEach((video) => {
        if (video !== currentVideo && !video.paused) {
          video.pause();
          const videoContainer = video.closest('.iconic-video-grid');
          const playIcon = videoContainer.querySelector('.iconic-video-play-button');
          const playIconSticky = videoContainer.querySelector('.iconic-sticky-play-icon');
          if (playIcon) playIcon.style.display = 'flex';
          if (playIconSticky) playIconSticky.style.display = 'block';
        }
      });
    }
  }

  customElements.define('iconic-video-gallery-with-product-second', IconicVideoGalleryProductsecond);
})();
